import { useGetUserProfileQuery } from '@/store/api/cc/userProfileApi';
/**
 * Hook to access user settings from RTK Query cache.
 *
 * @returns UserSettings or undefined if not loaded
 */
export const useUserSettings = () => {
    const { data: userProfile } = useGetUserProfileQuery();
    return userProfile === null || userProfile === void 0 ? void 0 : userProfile.settings;
};
/**
 * Hook to access analytics dashboards settings from RTK Query cache.
 *
 * @returns Analytics dashboards settings JSON string or '{}'
 */
export const useAnalyticsDashboardsSettings = () => {
    const settings = useUserSettings();
    return (settings === null || settings === void 0 ? void 0 : settings.analyticDashboardsSettings) || '{}';
};
/**
 * Hook to access analytics saved filters from RTK Query cache.
 *
 * @returns Analytics saved filters JSON string or '{}'
 */
export const useAnalyticDashboardsFilters = () => {
    const settings = useUserSettings();
    return (settings === null || settings === void 0 ? void 0 : settings.analyticsSavedFilters) || '{}';
};
/**
 * Hook to access preferred language from RTK Query cache.
 *
 * @returns Preferred language code or undefined
 */
export const usePreferredLanguage = () => {
    const settings = useUserSettings();
    return settings === null || settings === void 0 ? void 0 : settings.preferredLanguage;
};
